import { render, staticRenderFns } from "./assettrips.vue?vue&type=template&id=e90c7780&scoped=true"
import script from "./assettrips.js?vue&type=script&lang=js&external"
export * from "./assettrips.js?vue&type=script&lang=js&external"
import style0 from "./assettrips.vue?vue&type=style&index=0&id=e90c7780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90c7780",
  null
  
)

export default component.exports